import { Injectable } from "@angular/core";
import { PasswordStrength } from "./password-strength.enum";
import { StrengthPasswordService } from "./strength-password.service";
import { ValidationErrors } from "@angular/forms";

@Injectable({ providedIn: "root" })
export class PasswordStrengthValidator {
  constructor(private strengthPasswordSvc: StrengthPasswordService) { }

  validate(
    requiredStrength = PasswordStrength.Normal
  ) {
    return control => {
      const currentStrength = this.strengthPasswordSvc.getStrength(
        control.value || ""
      );

      if (currentStrength.strength < requiredStrength)
        return {
          minStrength: {
            strength: "Min strength not achieved",
            actualStrength: PasswordStrength[currentStrength.strength],
            requiredStrength: PasswordStrength[requiredStrength]
          }
        };

      return null;
    };
  }
}
